import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  children?: never;
  className?: string;
  label: string;
  labelClassName?: boolean;
  value: ReactNode;
};

export const PanelInfoItem = (props: Props) => {
  const { label, value, labelClassName, className } = props;
  return (
    <PanelInfoWrapper className={cx('panel-info-wrapper', className, labelClassName ? 'top-model-section' : 'about')}>
      <Label className="man-label">{label}:</Label>
      {value}
    </PanelInfoWrapper>
  );
};

const Label = styled.span`
  margin-right: 4px;
  color: ${(props) => props.theme.primary7};
`;

export const PanelInfoWrapper = styled.div`
  font-size: 0.9rem;

  &.about.modal-class {
    color: #000000;

    ${Label} {
      color: #adadad;
    }
  }
`;
